"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKpiExecutionDataView = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
/**
 * Wrapper around useExecutionDataView that does not treat no data errors as errors.
 * This allows formats for empty values to come into play when no data is returned.
 */
function useKpiExecutionDataView(config) {
    var primaryMeasure = config.primaryMeasure, backend = config.backend, effectiveFilters = config.effectiveFilters, secondaryMeasure = config.secondaryMeasure, workspace = config.workspace, shouldLoad = config.shouldLoad;
    var response = sdk_ui_1.useExecutionDataView({
        backend: backend,
        workspace: workspace,
        execution: shouldLoad
            ? {
                seriesBy: compact_1.default([primaryMeasure, secondaryMeasure]),
                filters: effectiveFilters,
            }
            : undefined,
    });
    return react_1.useMemo(function () {
        // do not treat no data as error here to give the user a chance to decide if no data is ok or not
        // instead return facade for the empty dataView provided by the error (it still has useful info
        // like measure format, name, etc.)
        if (response.status === "error" &&
            sdk_ui_1.isNoDataSdkError(response.error) &&
            sdk_backend_spi_1.isNoDataError(response.error.cause) &&
            response.error.cause.dataView) {
            return {
                result: sdk_ui_1.DataViewFacade.for(response.error.cause.dataView),
                error: undefined,
                status: "success",
            };
        }
        return response;
    }, [response]);
}
exports.useKpiExecutionDataView = useKpiExecutionDataView;
//# sourceMappingURL=useKpiExecutionDataView.js.map